import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { onChangePasswordDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import { validatePasswordField, isPasswordValid } from '../../../utils/passwordRules'
import PasswordStrength from '../../generic/PasswordStrength'
import keyUpHandler from '../../utils/keyUpHandler'
import '../../generic/RenderedField/styles.css'
import './styles.css'

export function ChangePassword({ onSubmit, hideGlobalNav, showGlobalNav }) {
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false)
  const [password1Visible, setPassword1Visible] = useState(false)
  const [password2Visible, setPassword2Visible] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting, errors, isDirty }
  } = useForm()

  const password1 = watch('password1')

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
  }, [hideGlobalNav, showGlobalNav])

  return (
    <div id="ChangePassword" className="auth-page">
      <div>
        <div className="logo">
          <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
        </div>

        <div className="change-password-box auth-form-box">
          <h1>Change your password</h1>
          <form id="SignInForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', { '-error': errors.oldPassword })}>
              <div className="field-container">
                <input
                  {...register('oldPassword', {
                    required: 'This field is required.'
                  })}
                  type={oldPasswordVisible ? 'text' : 'password'}
                  placeholder="Your old password"
                  aria-label="Your old password"
                />
                <i
                  className={classnames('icon', oldPasswordVisible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
                  onKeyUp={event => keyUpHandler(event, () => setOldPasswordVisible(!oldPasswordVisible))}
                  tabIndex="0"
                />
                <span
                  className={`field__error${!errors.oldPassword ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.oldPassword?.message}
                </span>
              </div>
            </div>
            <div className="forgot-password">
              <Link to="/users/password/new">Forgot password?</Link>
            </div>
            <div className={classnames('field', '-with-feedback', { '-error': errors.password1 })}>
              <div className="field-container">
                <input
                  {...register('password1', {
                    required: 'This field is required.',
                    validate: validatePasswordField
                  })}
                  type={password1Visible ? 'text' : 'password'}
                  placeholder="Your new password"
                  aria-label="Your new password"
                />
                <i
                  className={classnames('icon', password1Visible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword1Visible(!password1Visible)}
                  onKeyUp={event => keyUpHandler(event, () => setPassword1Visible(!password1Visible))}
                  tabIndex="0"
                />
                <span
                  className={`field__error${!errors.password1 ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.password1?.message}
                </span>
              </div>
            </div>
            <PasswordStrength password={password1} similarityTip />
            <div className={classnames('field', { '-error': errors.password2 })}>
              <div className="field-container">
                <input
                  {...register('password2', {
                    required: 'This field is required.',
                    validate: value => value === password1 || "passwords don't match"
                  })}
                  type={password2Visible ? 'text' : 'password'}
                  placeholder="Retype your new password"
                  aria-label="Retype your new password"
                />
                <i
                  className={classnames('icon', password2Visible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword2Visible(!password2Visible)}
                  onKeyUp={event => keyUpHandler(event, () => setPassword2Visible(!password2Visible))}
                  tabIndex="0"
                />
                <span
                  className={`field__error${!errors.password2 ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.password2?.message}
                </span>
              </div>
            </div>
            <button
              type="submit"
              className="btn -wide -blue-2"
              disabled={!isDirty || isSubmitting || !isPasswordValid(password1)}
            >
              Change password
            </button>
          </form>

          <div className="auth-alt">
            or <Link to="/login">Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

ChangePassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

export default connect(
  null,
  dispatchSelector
)(ChangePassword)
